(function () {
"use strict";
var $3d28d7f1aac198f5$exports = {};
function $8713978b2328d32b$export$2996f80ef42b8419(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}


function $ac6739cbe5bf1c84$export$ccedaf978f62b9dd(receiver, privateSet, fn) {
    if (!privateSet.has(receiver)) throw new TypeError("attempted to get private field on non-instance");
    return fn;
}


function $f86983e96b0c893e$export$6b10452b5ac97eba(obj, privateCollection) {
    if (privateCollection.has(obj)) throw new TypeError("Cannot initialize the same private elements twice on an object");
}


function $ea91727f98d0802f$export$1002c20f28174dbf(obj, privateSet) {
    (0, $f86983e96b0c893e$export$6b10452b5ac97eba)(obj, privateSet);
    privateSet.add(obj);
}


function $4fc75ccb937ab1df$var$_defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function $4fc75ccb937ab1df$export$d60067ff2358eee8(Constructor, protoProps, staticProps) {
    if (protoProps) $4fc75ccb937ab1df$var$_defineProperties(Constructor.prototype, protoProps);
    if (staticProps) $4fc75ccb937ab1df$var$_defineProperties(Constructor, staticProps);
    return Constructor;
}


function $c3b10a83b523f372$export$79e617b1955a2616(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}


function $c50969dc1df61e8b$export$7e0947b5ad3404e2(arr) {
    if (Array.isArray(arr)) return (0, $c3b10a83b523f372$export$79e617b1955a2616)(arr);
}


function $09c9f293d010c0e1$export$1eb58a6e75231000(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}


function $38c2d4931cb7a7c4$export$e6f3c4780d19eb2b() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}



function $d4f69c5c6c4654b1$export$a5be06335b3a083c(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return (0, $c3b10a83b523f372$export$79e617b1955a2616)(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return (0, $c3b10a83b523f372$export$79e617b1955a2616)(o, minLen);
}


function $227c6742e0ff6f82$export$1b5e630bc3aea29f(arr) {
    return (0, $c50969dc1df61e8b$export$7e0947b5ad3404e2)(arr) || (0, $09c9f293d010c0e1$export$1eb58a6e75231000)(arr) || (0, $d4f69c5c6c4654b1$export$a5be06335b3a083c)(arr) || (0, $38c2d4931cb7a7c4$export$e6f3c4780d19eb2b)();
}


function $0b5c99e6a0876eaa$export$5f0017c582d45a2d(obj) {
    "@swc/helpers - typeof";
    return obj && typeof Symbol !== "undefined" && obj.constructor === Symbol ? "symbol" : typeof obj;
}


"use strict";
var // Add your own methods here
$3d28d7f1aac198f5$var$_createEmptyState = /*#__PURE__*/ new WeakSet(), $3d28d7f1aac198f5$var$_getEmptyCells = /*#__PURE__*/ new WeakSet(), $3d28d7f1aac198f5$var$_addRandomTile = /*#__PURE__*/ new WeakSet(), $3d28d7f1aac198f5$var$_mergeCells = /*#__PURE__*/ new WeakSet(), $3d28d7f1aac198f5$var$_transpose = /*#__PURE__*/ new WeakSet(), $3d28d7f1aac198f5$var$_willStateChange = /*#__PURE__*/ new WeakSet(), $3d28d7f1aac198f5$var$_isWin = /*#__PURE__*/ new WeakSet(), $3d28d7f1aac198f5$var$_isLose = /*#__PURE__*/ new WeakSet(), $3d28d7f1aac198f5$var$_handleMove = /*#__PURE__*/ new WeakSet();
var $3d28d7f1aac198f5$var$Game = /*#__PURE__*/ function() {
    function Game() {
        var initialState = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : (0, $ac6739cbe5bf1c84$export$ccedaf978f62b9dd)(this, $3d28d7f1aac198f5$var$_createEmptyState, $3d28d7f1aac198f5$var$createEmptyState).call(this);
        (0, $8713978b2328d32b$export$2996f80ef42b8419)(this, Game);
        (0, $ea91727f98d0802f$export$1002c20f28174dbf)(this, $3d28d7f1aac198f5$var$_createEmptyState);
        (0, $ea91727f98d0802f$export$1002c20f28174dbf)(this, $3d28d7f1aac198f5$var$_getEmptyCells);
        (0, $ea91727f98d0802f$export$1002c20f28174dbf)(this, $3d28d7f1aac198f5$var$_addRandomTile);
        (0, $ea91727f98d0802f$export$1002c20f28174dbf)(this, $3d28d7f1aac198f5$var$_mergeCells);
        (0, $ea91727f98d0802f$export$1002c20f28174dbf)(this, $3d28d7f1aac198f5$var$_transpose);
        (0, $ea91727f98d0802f$export$1002c20f28174dbf)(this, $3d28d7f1aac198f5$var$_willStateChange);
        (0, $ea91727f98d0802f$export$1002c20f28174dbf)(this, $3d28d7f1aac198f5$var$_isWin);
        (0, $ea91727f98d0802f$export$1002c20f28174dbf)(this, $3d28d7f1aac198f5$var$_isLose);
        (0, $ea91727f98d0802f$export$1002c20f28174dbf)(this, $3d28d7f1aac198f5$var$_handleMove);
        this.initialState = initialState;
        this.state = this.initialState.map(function(row) {
            return (0, $227c6742e0ff6f82$export$1b5e630bc3aea29f)(row);
        });
        this.score = 0;
        this.status = "idle";
    }
    (0, $4fc75ccb937ab1df$export$d60067ff2358eee8)(Game, [
        {
            key: "moveLeft",
            value: function moveLeft() {
                var _this = this;
                if (this.status === "playing") {
                    var newState = this.state.map(function(row) {
                        return (0, $ac6739cbe5bf1c84$export$ccedaf978f62b9dd)(_this, $3d28d7f1aac198f5$var$_mergeCells, $3d28d7f1aac198f5$var$mergeCells).call(_this, row);
                    });
                    (0, $ac6739cbe5bf1c84$export$ccedaf978f62b9dd)(this, $3d28d7f1aac198f5$var$_handleMove, $3d28d7f1aac198f5$var$handleMove).call(this, newState);
                }
            }
        },
        {
            key: "moveRight",
            value: function moveRight() {
                var _this = this;
                if (this.status === "playing") {
                    var newState = this.state.map(function(row) {
                        var reversedRow = row.slice().reverse();
                        var mergedRow = (0, $ac6739cbe5bf1c84$export$ccedaf978f62b9dd)(_this, $3d28d7f1aac198f5$var$_mergeCells, $3d28d7f1aac198f5$var$mergeCells).call(_this, reversedRow);
                        return mergedRow.reverse();
                    });
                    (0, $ac6739cbe5bf1c84$export$ccedaf978f62b9dd)(this, $3d28d7f1aac198f5$var$_handleMove, $3d28d7f1aac198f5$var$handleMove).call(this, newState);
                }
            }
        },
        {
            key: "moveUp",
            value: function moveUp() {
                var _this = this;
                if (this.status === "playing") {
                    var transposedState = (0, $ac6739cbe5bf1c84$export$ccedaf978f62b9dd)(this, $3d28d7f1aac198f5$var$_transpose, $3d28d7f1aac198f5$var$transpose).call(this, this.state);
                    var newState = transposedState.map(function(row) {
                        return (0, $ac6739cbe5bf1c84$export$ccedaf978f62b9dd)(_this, $3d28d7f1aac198f5$var$_mergeCells, $3d28d7f1aac198f5$var$mergeCells).call(_this, row);
                    });
                    (0, $ac6739cbe5bf1c84$export$ccedaf978f62b9dd)(this, $3d28d7f1aac198f5$var$_handleMove, $3d28d7f1aac198f5$var$handleMove).call(this, (0, $ac6739cbe5bf1c84$export$ccedaf978f62b9dd)(this, $3d28d7f1aac198f5$var$_transpose, $3d28d7f1aac198f5$var$transpose).call(this, newState));
                }
            }
        },
        {
            key: "moveDown",
            value: function moveDown() {
                var _this = this;
                if (this.status === "playing") {
                    var transposedState = (0, $ac6739cbe5bf1c84$export$ccedaf978f62b9dd)(this, $3d28d7f1aac198f5$var$_transpose, $3d28d7f1aac198f5$var$transpose).call(this, this.state);
                    var newState = transposedState.map(function(row) {
                        var reversedRow = row.slice().reverse();
                        var mergedRow = (0, $ac6739cbe5bf1c84$export$ccedaf978f62b9dd)(_this, $3d28d7f1aac198f5$var$_mergeCells, $3d28d7f1aac198f5$var$mergeCells).call(_this, reversedRow);
                        return mergedRow.reverse();
                    });
                    (0, $ac6739cbe5bf1c84$export$ccedaf978f62b9dd)(this, $3d28d7f1aac198f5$var$_handleMove, $3d28d7f1aac198f5$var$handleMove).call(this, (0, $ac6739cbe5bf1c84$export$ccedaf978f62b9dd)(this, $3d28d7f1aac198f5$var$_transpose, $3d28d7f1aac198f5$var$transpose).call(this, newState));
                }
            }
        },
        {
            /**
   * @returns {number}
   */ key: "getScore",
            value: function getScore() {
                return this.score;
            }
        },
        {
            /**
   * @returns {number[][]}
   */ key: "getState",
            value: function getState() {
                return this.state;
            }
        },
        {
            /**
   * Returns the current game status.
   *
   * @returns {string} One of: 'idle', 'playing', 'win', 'lose'
   *
   * `idle` - the game has not started yet (the initial state);
   * `playing` - the game is in progress;
   * `win` - the game is won;
   * `lose` - the game is lost
   */ key: "getStatus",
            value: function getStatus() {
                return this.status;
            }
        },
        {
            /**
   * Starts the game.
   */ key: "start",
            value: function start() {
                this.status = "playing";
                (0, $ac6739cbe5bf1c84$export$ccedaf978f62b9dd)(this, $3d28d7f1aac198f5$var$_addRandomTile, $3d28d7f1aac198f5$var$addRandomTile).call(this);
                (0, $ac6739cbe5bf1c84$export$ccedaf978f62b9dd)(this, $3d28d7f1aac198f5$var$_addRandomTile, $3d28d7f1aac198f5$var$addRandomTile).call(this);
            }
        },
        {
            /**
   * Resets the game.
   */ key: "restart",
            value: function restart() {
                this.state = this.initialState.map(function(row) {
                    return (0, $227c6742e0ff6f82$export$1b5e630bc3aea29f)(row);
                });
                this.score = 0;
                this.status = "idle";
            }
        }
    ]);
    return Game;
}();
function $3d28d7f1aac198f5$var$createEmptyState() {
    return Array.from({
        length: 4
    }, function() {
        return Array(4).fill(0);
    });
}
function $3d28d7f1aac198f5$var$getEmptyCells() {
    var emptyCells = [];
    this.state.forEach(function(row, rowIndex) {
        row.forEach(function(cell, cellIndex) {
            if (cell === 0) emptyCells.push({
                rowIndex: rowIndex,
                cellIndex: cellIndex
            });
        });
    });
    return emptyCells;
}
function $3d28d7f1aac198f5$var$addRandomTile() {
    var emptyCells = (0, $ac6739cbe5bf1c84$export$ccedaf978f62b9dd)(this, $3d28d7f1aac198f5$var$_getEmptyCells, $3d28d7f1aac198f5$var$getEmptyCells).call(this);
    if (emptyCells.length === 0) return;
    var randomCell = emptyCells[Math.floor(Math.random() * emptyCells.length)];
    var value = Math.random() > 0.1 ? 2 : 4;
    this.state[randomCell.rowIndex][randomCell.cellIndex] = value;
}
function $3d28d7f1aac198f5$var$mergeCells(row) {
    var _newRow;
    var mergedRow = row.filter(function(cell) {
        return cell !== 0;
    });
    var newRow = [];
    var i = 0;
    while(i < mergedRow.length)if (mergedRow[i] === mergedRow[i + 1]) {
        newRow.push(mergedRow[i] * 2);
        this.score += mergedRow[i] * 2;
        i += 2;
    } else {
        newRow.push(mergedRow[i]);
        i += 1;
    }
    (_newRow = newRow).push.apply(_newRow, (0, $227c6742e0ff6f82$export$1b5e630bc3aea29f)(Array(4 - newRow.length).fill(0)));
    return newRow;
}
function $3d28d7f1aac198f5$var$transpose(matrix) {
    return matrix[0].map(function(_, colIndex) {
        return matrix.map(function(row) {
            return row[colIndex];
        });
    });
}
function $3d28d7f1aac198f5$var$willStateChange(newState) {
    return JSON.stringify(this.state) !== JSON.stringify(newState);
}
function $3d28d7f1aac198f5$var$isWin() {
    this.status = this.state.some(function(row) {
        return row.includes(2048);
    }) ? "win" : this.status;
}
function $3d28d7f1aac198f5$var$isLose() {
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    try {
        var _loop = function() {
            var row = _step.value;
            if (row.some(function(i) {
                return i === 0;
            })) return {
                v: false
            };
            for(var i = 0; i < row.length; i++){
                if (row[i] === row[i + 1]) return {
                    v: false
                };
            }
        };
        for(var _iterator = this.state[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
            var _ret = _loop();
            if ((0, $0b5c99e6a0876eaa$export$5f0017c582d45a2d)(_ret) === "object") return _ret.v;
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator.return != null) {
                _iterator.return();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
    for(var c = 0; c < 4; c++){
        var row = [
            this.state[0][c],
            this.state[1][c],
            this.state[2][c],
            this.state[3][c]
        ];
        for(var i = 0; i < row.length; i++){
            if (row[i] === row[i + 1]) return false;
        }
    }
    return true;
}
function $3d28d7f1aac198f5$var$handleMove(newState) {
    if ((0, $ac6739cbe5bf1c84$export$ccedaf978f62b9dd)(this, $3d28d7f1aac198f5$var$_willStateChange, $3d28d7f1aac198f5$var$willStateChange).call(this, newState)) {
        this.state = newState;
        (0, $ac6739cbe5bf1c84$export$ccedaf978f62b9dd)(this, $3d28d7f1aac198f5$var$_addRandomTile, $3d28d7f1aac198f5$var$addRandomTile).call(this);
        (0, $ac6739cbe5bf1c84$export$ccedaf978f62b9dd)(this, $3d28d7f1aac198f5$var$_isWin, $3d28d7f1aac198f5$var$isWin).call(this);
        if ((0, $ac6739cbe5bf1c84$export$ccedaf978f62b9dd)(this, $3d28d7f1aac198f5$var$_isLose, $3d28d7f1aac198f5$var$isLose).call(this)) this.status = "lose";
    }
}
$3d28d7f1aac198f5$exports = $3d28d7f1aac198f5$var$Game;


var $197cd56b15c33885$var$game = new $3d28d7f1aac198f5$exports();
// Uncomment the next lines to use your game instance in the browser
// [
//   [2, 0, 2, 2],
//   [0, 2, 2, 2],
//   [2, 2, 0, 2],
//   [2, 2, 2, 0],
// ]
// Write your code here
var $197cd56b15c33885$var$startButton = document.querySelector(".button", ".start");
function $197cd56b15c33885$var$updateTable() {
    var gameState = $197cd56b15c33885$var$game.getState();
    var table = document.querySelector(".game-field");
    var tbody = table.querySelector("tbody");
    tbody.innerHTML = "";
    for(var i = 0; i < gameState.length; i++){
        var row = gameState[i];
        var tr = document.createElement("tr");
        tr.className = "field-row";
        for(var j = 0; j < row.length; j++){
            var cell = row[j];
            var td = document.createElement("td");
            td.textContent = cell !== 0 ? cell : "";
            td.className = cell !== 0 ? "field-cell field-cell--".concat(cell) : "field-cell";
            tr.appendChild(td);
        }
        tbody.appendChild(tr);
    }
}
function $197cd56b15c33885$var$updateScore() {
    var gameScore = document.querySelector(".game-score");
    gameScore.innerText = $197cd56b15c33885$var$game.getScore();
}
function $197cd56b15c33885$var$handleMessages(action, type) {
    var startMessage = document.querySelector(".message-start");
    var winMessage = document.querySelector(".message-win");
    var loseMessage = document.querySelector(".message-lose");
    if (action === "hide") switch(type){
        case "start":
            startMessage.classList.add("hidden");
            break;
        case "win":
            winMessage.classList.add("hidden");
            break;
        case "lose":
            loseMessage.classList.add("hidden");
            break;
        default:
            break;
    }
    if (action === "show") switch(type){
        case "start":
            startMessage.classList.remove("hidden");
            break;
        case "win":
            winMessage.classList.remove("hidden");
            break;
        case "lose":
            loseMessage.classList.remove("hidden");
            break;
        default:
            break;
    }
}
function $197cd56b15c33885$var$handleGameStatus() {
    switch($197cd56b15c33885$var$game.getStatus()){
        case "win":
            $197cd56b15c33885$var$handleMessages("show", "win");
            break;
        case "lose":
            $197cd56b15c33885$var$handleMessages("show", "lose");
            break;
        default:
            break;
    }
}
function $197cd56b15c33885$var$updateGame() {
    $197cd56b15c33885$var$updateTable();
    $197cd56b15c33885$var$updateScore();
    $197cd56b15c33885$var$handleGameStatus();
}
$197cd56b15c33885$var$startButton.addEventListener("click", function() {
    switch($197cd56b15c33885$var$game.getStatus()){
        case "idle":
            $197cd56b15c33885$var$game.start();
            $197cd56b15c33885$var$updateTable();
            $197cd56b15c33885$var$startButton.className = "button restart";
            $197cd56b15c33885$var$startButton.textContent = "Restart";
            $197cd56b15c33885$var$handleMessages("hide", "start");
            $197cd56b15c33885$var$updateScore();
            break;
        case "playing":
            $197cd56b15c33885$var$game.restart();
            $197cd56b15c33885$var$updateTable();
            $197cd56b15c33885$var$startButton.className = "button start";
            $197cd56b15c33885$var$startButton.textContent = "Start";
            $197cd56b15c33885$var$handleMessages("show", "start");
            $197cd56b15c33885$var$updateScore();
            break;
        case "win":
            $197cd56b15c33885$var$game.restart();
            $197cd56b15c33885$var$updateTable();
            $197cd56b15c33885$var$startButton.className = "button start";
            $197cd56b15c33885$var$startButton.textContent = "Start";
            $197cd56b15c33885$var$handleMessages("hide", "win");
            $197cd56b15c33885$var$handleMessages("show", "start");
            $197cd56b15c33885$var$updateScore();
            break;
        case "lose":
            $197cd56b15c33885$var$game.restart();
            $197cd56b15c33885$var$updateTable();
            $197cd56b15c33885$var$startButton.className = "button start";
            $197cd56b15c33885$var$startButton.textContent = "Start";
            $197cd56b15c33885$var$handleMessages("hide", "lose");
            $197cd56b15c33885$var$handleMessages("show", "start");
            $197cd56b15c33885$var$updateScore();
            break;
        default:
            break;
    }
});
document.addEventListener("keydown", function(e) {
    switch(e.key){
        case "ArrowLeft":
            $197cd56b15c33885$var$game.moveLeft();
            $197cd56b15c33885$var$updateGame();
            break;
        case "ArrowRight":
            $197cd56b15c33885$var$game.moveRight();
            $197cd56b15c33885$var$updateGame();
            break;
        case "ArrowUp":
            $197cd56b15c33885$var$game.moveUp();
            $197cd56b15c33885$var$updateGame();
            break;
        case "ArrowDown":
            $197cd56b15c33885$var$game.moveDown();
            $197cd56b15c33885$var$updateGame();
            break;
        default:
            break;
    }
});

})();
//# sourceMappingURL=index.83f2c579.js.map
